<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 0H5V2H2V5H0V2C0 0.89543 0.895431 0 2 0ZM0 13H2V16H5V18H2C0.89543 18 0 17.1046 0 16V13ZM13 18H16C17.1046 18 18 17.1046 18 16V13H16V16H13V18ZM16 5V2H13V0H16C17.1046 0 18 0.895431 18 2V5H16Z"
  />
</template>
